import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import styles from "../../../hygienist/ProfilePage/components/components.module.scss";

interface AboutMeCompletedModalProps {
    onClose: (e: React.MouseEvent) => void;
    onCompleteAboutMe: () => void;
}

const AboutMeCompletedModal: React.FC<AboutMeCompletedModalProps> = ({
    onClose,
    onCompleteAboutMe
}) => {
    return (
        <div className={styles.wizardModalOverlay} onClick={onClose}>
            <div className={styles.wizardModalContainer} onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className={styles.wizardModalHeader}>
                    <div className={styles.wizardHeaderContent}>
                        <h1 className={styles.wizardModalTitle}>Continue without "About Me"?</h1>
                    </div>
                    <button className={styles.wizardCloseButton} onClick={onClose} aria-label="Close modal">
                        <CloseIcon />
                    </button>
                </div>

                {/* Body */}
                <div className={styles.wizardModalBody}>
                    <div className={styles.wizardInfoBox}>
                        <p>Complete your "About Me" section to show dental offices how you shine! Profiles with a complete "About Me" section are 20% more likely to be accepted, and give you a chance to show your unique qualities to the dental office.</p>
                        <p>Even if you're not great at writing, we have a writing assistant that can help you craft the perfect way to express yourself.</p>
                    </div>
                </div>

                {/* Footer */}
                <div className={styles.wizardModalFooter}>
                    <button
                        className={styles.wizardCancelButton}
                        onClick={onClose}
                    >
                        I'll do this later
                    </button>
                    <button
                        className={styles.wizardSaveButton}
                        onClick={onCompleteAboutMe}
                    >
                        Complete "About Me"
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AboutMeCompletedModal;
